<template>
  <div v-if="isLoading !== true">
    <b-row :key="dataJawab[currentIndexAll]">
      <b-col md="12">
        <b-card class="shadow rounded-3">
          <template
            v-if="pattern2.test(dataSoal.soal.soal) === true"
          ></template>
          <template v-else class="fs-2" :id="'soal-' + dataSoal.soal.id">
            <div class="width-judul">
              <p v-html="removeSpanStyleInParagraph(dataSoal.soal.soal)"></p>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="px-2">
      <template
        v-if="
          dataSoal.soal.pila === null ||
            removeStyleBlocks(dataSoal.soal.pila) === '-' ||
            (pattern.test(dataSoal.soal.pila) &&
              !dataSoal.soal.pila.match(/^-[^-]+$/) === true)
        "
      />
      <b-col md="12" class="px-0 mb-2">
        <label
          style="gap: 10px;"
          class="position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2"
        >
          <input
            :key="dataSoal.soal.id + currentIndexAll"
            :id="'jawab-a-' + dataSoal.soal.id"
            type="radio"
            :value="
              'A/' +
                dataSoal.soal.id +
                '/' +
                dataSoal.user +
                '/' +
                currentIndexAll
            "
            :class="
              jawabanUser[currentIndexAll] &&
              jawabanUser[currentIndexAll].charAt(0) === 'A'
                ? 'pil pil-a option-input radio option-input-custom'
                : 'pil pil-a option-input radio'
            "
            v-model="jawabanUser[currentIndexAll]"
            @click="
              nextSubmit(
                'A/' +
                  dataSoal.soal.id +
                  '/' +
                  dataSoal.user +
                  '/' +
                  currentIndexAll
              )
            "
          />
          <div class="font-custom ds-custom">
            <p v-html="removeStyleBlocks(dataSoal.soal.pila)"></p>
          </div>
        </label>
      </b-col>
      <template
        v-if="
          dataSoal.soal.pilb === null ||
            removeStyleBlocks(dataSoal.soal.pilb) === '-' ||
            (pattern.test(dataSoal.soal.pilb) &&
              !dataSoal.soal.pilb.match(/^-[^-]+$/) === true)
        "
      />
      <b-col md="12" class="px-0 mb-2">
        <label
          style="gap: 10px;"
          class="position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2"
        >
          <input
            :key="dataSoal.soal.id + currentIndexAll"
            :id="'jawab-b-' + dataSoal.soal.id"
            type="radio"
            :value="
              'B' +
                '/' +
                dataSoal.soal.id +
                '/' +
                dataSoal.user +
                '/' +
                currentIndexAll
            "
            :class="[
              'pil',
              'pil-b',
              'option-input',
              'radio',
              {
                'option-input-custom':
                  jawabanUser[currentIndexAll] &&
                  jawabanUser[currentIndexAll].charAt(0) === 'B',
              },
            ]"
            v-model="jawabanUser[currentIndexAll]"
            @click="
              nextSubmit(
                'B' +
                  '/' +
                  dataSoal.soal.id +
                  '/' +
                  dataSoal.user +
                  '/' +
                  currentIndexAll
              )
            "
          />
          <div class="font-custom ds-custom">
            <p v-html="removeStyleBlocks(dataSoal.soal.pilb)"></p>
          </div>
        </label>
      </b-col>
      <template
        v-if="
          dataSoal.soal.pilc === null ||
            removeStyleBlocks(dataSoal.soal.pilc) === '-' ||
            (pattern.test(dataSoal.soal.pilc) &&
              !dataSoal.soal.pilc.match(/^-[^-]+$/) === true)
        "
      />
      <b-col md="12" class="px-0 mb-2" v-else>
        <label
          style="gap: 10px;"
          class="position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2"
        >
          <input
            :key="dataSoal.soal.id + currentIndexAll"
            :id="'jawab-c-' + dataSoal.soal.id"
            type="radio"
            :class="
              jawabanUser[currentIndexAll] &&
              jawabanUser[currentIndexAll].charAt(0) === 'C'
                ? 'pil pil-c option-input radio option-input-custom'
                : 'pil pil-c option-input radio'
            "
            :value="
              'C/' +
                dataSoal.soal.id +
                '/' +
                dataSoal.user +
                '/' +
                currentIndexAll
            "
            v-model="jawabanUser[currentIndexAll]"
            @click="
              nextSubmit(
                'C/' +
                  dataSoal.soal.id +
                  '/' +
                  dataSoal.user +
                  '/' +
                  currentIndexAll
              )
            "
          />
          <div class="font-custom ds-custom">
            <p v-html="removeStyleBlocks(dataSoal.soal.pilc)"></p>
          </div>
        </label>
      </b-col>
      <template
        v-if="
          dataSoal.soal.pild === null ||
            removeStyleBlocks(dataSoal.soal.pild) === '-' ||
            (pattern.test(dataSoal.soal.pild) &&
              !dataSoal.soal.pild.match(/^-[^-]+$/) === true)
        "
      />
      <b-col md="12" class="px-0 mb-2" v-else>
        <label
          style="gap: 10px;"
          class="position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2"
        >
          <input
            :key="dataSoal.soal.id + currentIndexAll"
            :id="'jawab-d-' + dataSoal.soal.id"
            type="radio"
            :class="
              jawabanUser[currentIndexAll] &&
              jawabanUser[currentIndexAll].charAt(0) === 'D'
                ? 'pil pil-d option-input radio option-input-custom'
                : 'pil pil-d option-input radio'
            "
            :value="
              'D/' +
                dataSoal.soal.id +
                '/' +
                dataSoal.user +
                '/' +
                currentIndexAll
            "
            v-model="jawabanUser[currentIndexAll]"
            @click="
              nextSubmit(
                'D/' +
                  dataSoal.soal.id +
                  '/' +
                  dataSoal.user +
                  '/' +
                  currentIndexAll
              )
            "
          />
          <div class="font-custom ds-custom">
            <p v-html="removeStyleBlocks(dataSoal.soal.pild)"></p>
          </div>
        </label>
      </b-col>
      <template
        v-if="
          dataSoal.soal.pile === null ||
            removeStyleBlocks(dataSoal.soal.pile) === '-' ||
            (pattern.test(dataSoal.soal.pile) &&
              !dataSoal.soal.pile.match(/^-[^-]+$/) === true)
        "
      />
      <b-col md="12" class="px-0" v-else>
        <label
          style="gap: 10px;"
          class="position-relative cursor-pointer d-flex justify-content-start align-items-center bg-choice shadow px-3 py-2"
        >
          <input
            :key="dataSoal.soal.id + currentIndexAll"
            :id="'jawab-e-' + dataSoal.soal.id"
            type="radio"
            :class="
              jawabanUser[currentIndexAll] &&
              jawabanUser[currentIndexAll].charAt(0) === 'E'
                ? 'pil pil-e option-input radio option-input-custom'
                : 'pil pil-e option-input radio'
            "
            :value="
              'E/' +
                dataSoal.soal.id +
                '/' +
                dataSoal.user +
                '/' +
                currentIndexAll
            "
            v-model="jawabanUser[currentIndexAll]"
            @click="
              nextSubmit(
                'E/' +
                  dataSoal.soal.id +
                  '/' +
                  dataSoal.user +
                  '/' +
                  currentIndexAll
              )
            "
          />
          <div class="font-custom ds-custom">
            <p v-html="removeStyleBlocks(dataSoal.soal.pile)"></p>
          </div>
        </label>
      </b-col>
    </b-row>
  </div>

  <div class="d-flex justify-content-center mb-3" v-else>
    <loading-vue></loading-vue>
  </div>
</template>

<script>
import axios from "axios";
import loadingVue from "@/components/loading.vue";
import "@/assets/scss/custom-ujian.scss";

export default {
  components: { loadingVue },
  props: {
    dataSoal: Object,
    idNextSoal: [Number, String],
    currentIndexAll: Number,
    jawabanUser: Array,
  },
  data() {
    return {
      dataJawab: [],
      isLoading: false,
      checkMultiple: false,
      pattern: /^[-]+$/,
      pattern2: /^\.+$/,
      jawabCheckbox: [],
      setSoal: null,
      setIdSoal: this.idNextSoal,
      setDataSoal: null,
      options: ["A", "B", "C", "D", "E"],
    };
  },
  mounted() {
    this.checkMultipleOrNot();
    setInterval(async () => {
      if (this.dataJawab.length > 0) {
        await this.simpanJawaban();
      }
    }, 5000);
  },
  computed: {},
  watch: {
    dataSoal(val) {
      if (val) {
        // if (val.soal.kunci !== null) {
        //   if (val.soal.kunci.includes(",")) {
        //     this.checkMultiple = true;
        //     this.$emit("setMultiple", true);
        //   } else {
        //     this.checkMultiple = false;
        //     this.$emit("setMultiple", false);
        //   }
        // }
      }
    },

    jawabanUser(val) {
      this.$emit("nextQuestion", true);

      return val;
    },

    idNextSoal(newValue) {
      this.setIdSoal = newValue;
    },
  },

  methods: {
    /**
     * Remove all style blocks, <style> tags and all style attributes
     * from input string.
     * @param {string} input - The string to remove style blocks from.
     * @return {string} The string with all style blocks removed.
     */
    removeStyleBlocks(input) {
      const regex = /<style\b[^>]*>([\s\S]*?)<\/style>/gi;
      let style = input.replace(regex, "");
      style = style.replace(/<\/?(?!img)[^>]+>/g, "");
      style = style.replace(/\s?style=(["'])(?:(?!\1).)*\1/g, "");

      // style = style.replace(/(^|\s|&nbsp;)+/g, "");
      return style;
    },
    removeSpanStyleInParagraph(input) {
      // Mengganti font-size di dalam elemen <span> menjadi 24px
      const result = input.replace(
        /<span[^>]*style="[^"]*font-size:[^"]*;?[^"]*"[^>]*>/gi,
        function(match) {
          return match.replace(/font-size:[^;]*;/gi, "font-size: 22px;");
        }
      );

      // Jika <span> tidak memiliki style font-size, kita tambahkan style font-size: 24px;
      const finalResult = result.replace(
        /<span(?![^>]*style)[^>]*>/gi,
        function(match) {
          return match.replace(/<span/, '<span style="font-size: 24px;"');
        }
      );

      // Menghapus seluruh atribut style dari elemen <img>
      const updatedResult = finalResult.replace(
        /<img([^>]*)\sstyle="[^"]*"([^>]*)>/gi,
        "<img$1$2>"
      );

      return updatedResult;
    },
    async simpanJawaban() {
      const log = this.dataJawab;
      this.dataJawab = [];
      localStorage.setItem("jawaban", JSON.stringify(log));
      await this.saveJawab(log);
    },

    async saveJawab(value) {
      await axios
        .post(process.env.VUE_APP_API_BASE_URL + "/api/json/ujian/jawab-all", {
          get_jawab: value,
        })
        .then(() => {
          return "Success";
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async nextSubmit(value) {
      // Memisahkan dataJawab menjadi komponennya
      const idxsoal = value.split("/")[3];

      // Perbarui jawaban pada indeks yang sesuai
      if (this.jawabanUser[idxsoal] === value) {
        // console.log("Some");
        this.$emit("nextQuestion", true);
      }

      this.jawabanUser[idxsoal] = value;
      this.dataJawab.push(value);
    },

    async checkMultipleOrNot() {
      if (this.setDataSoal !== null) {
        if (this.setDataSoal.soal.kunci !== null) {
          if (this.setDataSoal.soal.kunci.includes(",")) {
            this.checkMultiple = true;
            this.$emit("setMultiple", true);
          }
        }
      }
    },

    handleCheckboxChange(value) {
      this.jawabCheckbox = value;
      this.$emit("dataCheckbox", this.jawabCheckbox);
      if (this.jawabCheckbox !== null) {
        let elements = document.getElementsByClassName(
          "form-check-input-custom"
        );
        while (elements.length > 0) {
          elements[0].classList.remove("form-check-input-custom");
        }
      }
    },
  },
};
</script>

<style>
@media screen and (max-width: 992px) {
  span.width-judul > img {
    max-width: 100%;
    height: auto;
  }

  span.width-judul > p {
    font-size: 1.2rem;
    line-height: 1.5;
  }
}

@media screen and (max-width: 576px) {
  span.width-judul > p {
    font-size: 1rem;
  }
}

.option-input {
  top: 0 !important;
  position: relative;
}

p > img {
  height: unset !important;
}

.pil-a::after {
  content: "A";
  font-size: 20px;
  position: absolute;
  top: -4px;
  left: 11px;
  font-weight: 700;
}

.pil-b::after {
  content: "B";
  font-size: 20px;
  position: absolute;
  top: -4px;
  left: 11px;
  font-weight: 700;
}

.pil-c::after {
  content: "C";
  font-size: 20px;
  position: absolute;
  top: -4px;
  left: 11px;
  font-weight: 700;
}

.pil-d::after {
  content: "D";
  font-size: 20px;
  position: absolute;
  top: -4px;
  left: 11px;
  font-weight: 700;
}

.pil-e::after {
  content: "E";
  font-size: 20px;
  position: absolute;
  top: -4px;
  left: 11px;
  font-weight: 700;
}
</style>
